import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { getAuthenticator, getRequestConfig } from '../../auth/auth.js'
import RoleContext from '../../auth/RoleContext.js'
import { ROLES } from '../../auth/role'
import NfpStandardView from "./nfpViews/NfpStandardView.js"
import NfpSupplementedView from "./nfpViews/NfpSupplementedView.js"
import NfpSuppressedView from "./nfpViews/NfpSuppressedView.js";
import CanadianFlagIcon from '../../img/flag-canada.js'
import { ArrowCircleDown, ArrowCircleUp } from "@mui/icons-material";
import { collapseSidebar } from '../../layout/Header.js'
import axios from 'axios'
import Page from '../../layout/Page.js'
import he from 'he'
import Event from '../../utils/EventNames.js';
import { default as bus } from '../../utils/EventBus.js'
import { Tab, Tabs, TabPanel} from '../../layout/Tabs.js'
import LDSInput from '../../form/LDSInput.js'
import { HorizontalRule } from '../../layout/HorizontalRule.js'
import { handleFieldChange, handleSelectChange, handleCheckboxChange } from '../../form/Form.js'
import { Article as ArticleIcon, Download as DownloadIcon, Email as EmailIcon, Forward as ForwardIcon, Share as ShareIcon } from '@mui/icons-material'
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Grid2 as Grid, MenuItem, Paper, Select, TextField, Tooltip, Typography } from '@mui/material'
import Panel from "../../layout/Panel.js";
import { ApiGateway, FeatureFlags, SraPortalDomain, SraSfdcDomain } from '../../config/config.js'
import LabelDeclarationSheetPdfTemplate from '../LabelDeclarationSheet.pdf.js'
import StatusChip from '../../layout/StatusChip.js'
import b64toBlob from 'b64-to-blob'
import moment from 'moment'
import EmailDialog from "../../form/EmailDialog.js"
import { styled, keyframes } from '@mui/system';
const basePath = ApiGateway.labelDeclarationSheets
const fade = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
`;

const pulse = keyframes`
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.7);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 10px 5px rgba(0, 123, 255, 0.2);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 123, 255, 0);
  }
`;

const BlinkingBox = styled(Box)`
  animation: ${fade} 1s infinite ease-in-out;
`;

export const getLabel = (s, isAbbreviated, isNotASignficantSource = false, isLast = false) => {
  let label = isAbbreviated && s?.abbreviation ? s.abbreviation : s?.label
  if(isNotASignficantSource && isLast) {
    label = ('' + label).endsWith('.') ? label : `${label}.`
  }
  let regex = /\btrans\b/g
  return ('' + label).replace(regex, <span style={{fontStyle:'italic'}}>trans</span>)
}

export default function CanadianLdsEntryPage (props) {
    const roleCtx = useContext(RoleContext)
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false);
    const [showCancelModal, setShowCancelModal] = useState(false)

    const ldsDefaults = {status: 'review', layout: 'standard', isIngredientsPrefixVisible: true, isSupplementedFoodFactsRequired: false}
    const [lds, setLds] = useState(ldsDefaults);
    const [ldsInfo, setLdsInfo] = useState({});
    const [nfp1, setNfp1] = useState({});
    const [nfp2, setNfp2] = useState({});
    const [activeTab, setActiveTab] = useState('Nfp');
    const [isReadOnly, setIsReadOnly] = useState(!(roleCtx.hasRole([ROLES.ADMIN, ROLES.SRA_ADMIN, ROLES.SRA_USER])));
    const [isDirty, setIsDirty] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [significantSourceText, setSignificantSourceText] = useState();
    const [account, setAccount] = useState(getAuthenticator().getCurrentAccount())
    const [allSraUsers, setAllSraUsers] = useState([])
    const [isEmailDialogVisible, setIsEmailDialogVisible] = useState(false);
    const [emailTo, setEmailTo] = useState([]);
    const [emailBody, setEmailBody] = useState('Hello, I am sharing a Label Declaration Sheet with you.  Please review it and let me know if you have any questions.')
    const [emailError, setEmailError] = useState(false)
    const emailSubject = `${account.name}: SRA LDS Sharing`

    const { id } = useParams()

    const setNfp1AmountState = (value) => {
      let newNfp1 = structuredClone(nfp1)
      let keys = Object.keys(value)
      let id = keys.length ? keys[0] : undefined
      if(newNfp1[id]) {
        newNfp1[id].amountState = value[id]
        setNfp1(newNfp1)
      }
    }

    const setNfp1PercentState = (value) => {
      let newNfp1 = structuredClone(nfp1)
      let keys = Object.keys(value)
      let id = keys.length ? keys[0] : undefined
      if(newNfp1[id]) {
        newNfp1[id].percentState = value[id]
        setNfp1(newNfp1)
      }
    }

    const setDirty = () => {
      if(!isDirty) {
        setIsDirty(true)

        bus.emit(Event.ALERT, {
          text: 'Please remember to save your changes!',
          style: 'warn'
        })
      }
    }

    useEffect(() => {
      (async() => {
          const requestConfig = await getRequestConfig()
          
          const sraUsersResponse = await axios.get(`${ApiGateway.employee}/roles/4%2C5%2C14?sorting=lastName@@@firstName`, requestConfig)
          if(sraUsersResponse?.status === 200) {
            const _allSraUsers = sraUsersResponse.data?.data ?? []
            setAllSraUsers(_allSraUsers)
          }
      })()
      collapseSidebar()
    },[]);

    // const setNfp1 = (nfp1) => {
    //   setNfp(prevNfp => {
    //     const newNfp = { nfpDefaults, ...prevNfp }
    //     newNfp.nfp1 = nfp1
    //     return newNfp
    //   })
    // }

    useEffect(() => {
        (async() => {
            setIsLoading(true)
            const requestConfig = await getRequestConfig()
            const ldsResponse = await axios.get(`${basePath}/products/${id}/nfp`, requestConfig)
            // console.log('ldsResponse: ', ldsResponse)
            if(ldsResponse?.status === 200) {
                // console.log('nfpResponse.data: ', nfpResponse.data)

                let newLds = ldsResponse.data?.data ?? {}
                const countryId = newLds.formula?.regulation?.countryId
                if(countryId === 124) {
                  newLds.status = (newLds.status ?? '').trim().length > 0 ? newLds.status : 'review'
                  newLds.layout = (newLds.layout ?? '').trim().length > 0 ? newLds.layout : 'standard'
                  newLds.isIngredientsPrefixVisible = newLds.isIngredientsPrefixVisible ?? true
                  setLds(newLds)
                  setNfps(newLds)
                  const ldsInfoResponse = await axios.get(`${basePath}/products/${id}/lds-information`, requestConfig)
                  if(ldsInfoResponse.status === 200) {
                      // console.log('ldsInfoResponse.data: ', ldsInfoResponse.data)
                      setLdsInfo(ldsInfoResponse.data?.data)
                  }
                } else if(countryId === 840) {
                  navigate(`/label-declaration-sheets/ca/products/${id}/entry`)
                } else {
                  console.log('Unsupported country!')
                }
            }
            setIsLoading(false)
        })()
    }, [id])

    const setNfps = (lds = {}) => {
      // console.log('setting Nfps...', lds)
      const mapNutrientInfo = (nutrientInfos) => {
        if(nutrientInfos?.length) {

          
          return nutrientInfos.reduce((nfp, nutrientInfo, idx) => {
            let { nutrient } = nutrientInfo
            let value = nutrientInfo.byServing?.roundedValue ?? 0
            let percent = nutrientInfo.byServing?.roundedDailyValue ?? 0
            let isMandatory = nutrientInfo.isMandatory
            let showAmount = nutrientInfo.showAmount ?? true
            let showPercent = nutrientInfo.showPercent ?? true
            let isSupplement = nutrientInfo.isSupplement ?? false
            let amountState = nutrientInfo.amountState
            if(showAmount && !amountState) {
              amountState = nutrientInfo.isMandatory ? 'Visible' : value > 0 ? 'Visible' : 'Hidden'
            }
            let percentState = nutrientInfo.percentState
            if(showPercent && !percentState) {
              percentState = nutrientInfo.isMandatory ? 'Visible' : percent > 0 ? 'Visible' : 'Hidden'
            }
            const isMicroNutrient = nutrientInfo.nutrient?.isMicroNutrient
            nfp[nutrient.id] = {
              id: nutrient.id,
              label: nutrient.name,
              abbreviation: nutrient.abbreviation,
              value,
              amountState,
              percent,
              percentState,
              isMandatory,
              showAmount,
              showPercent,
              isMicroNutrient,
              isSupplement,
              sequence: nutrientInfo.sequence,
              sequenceSupplemental: nutrientInfo.sequenceSupplemental,
              uom: nutrientInfo?.nutrient?.uom?.abbreviation,
              includeInView: nutrientInfo.sequence > -1
            }
            
            return nfp
          }, {})
        }
      }

      if(lds.nfp1) {
        let { nutrientInfos } = lds.nfp1
        let newNfp1 = mapNutrientInfo(nutrientInfos, lds)
        setNfp1(newNfp1)
      }
    }

    const setSupplement1 = (id, isSupplement) => {
      let newNfp1 = structuredClone(nfp1)

      if(newNfp1[id]) {
        newNfp1[id].isSupplement = isSupplement
        setNfp1(newNfp1)
      }
    }

    useEffect(() => {
      setNfps(lds)
    }, [lds.layout])

    useEffect(() => {
      // setNutrientList(getNutrientList(nfp.nfp1, nfp.nfp2))
      if(nfp1 || nfp2) {
        let text = getSignificantSourceText(activeTab === 'Nfp2' ? nfp2 : nfp1)
        // console.log('sig: ', text)
        setSignificantSourceText(text)
      }
    }, [lds, nfp1, nfp2])

    const getSignificantSourceText = (nfp = {}) => {
      // console.log('getSignificantSourceText, nfp: ', nfp)
      
      
      //All these nutrients are insignificant if less than 2% of DV
      const sources1 = [
        nfp['84a8709a-0012-0000-ebf9-90cea7d9d44f'], //'saturatedFat', 
        nfp['84a8709a-0015-0000-ebf9-90cea7d9d44f'], //'transFat', 
        nfp['84a8709a-0014-0000-ebf9-90cea7d9d44f'], //'polyFat', 
        nfp['84a8709a-0013-0000-ebf9-90cea7d9d44f'], //'monoFat', 
        nfp['84a8709a-0016-0000-ebf9-90cea7d9d44f'], //'cholesterol', 
        nfp['84a8709a-0003-0000-ebf9-90cea7d9d44f'] //'dietaryFiber'
      ]

      const sources2 = [
        nfp['84a8709a-0094-0000-ebf9-90cea7d9d44f'], //'addedSugars',
        nfp['84a8709a-0026-0000-ebf9-90cea7d9d44f'], //vitaminD',
        nfp['84a8709a-002f-0000-ebf9-90cea7d9d44f'], //'calcium',
        nfp['84a8709a-0035-0000-ebf9-90cea7d9d44f'], //'iron',
        nfp['84a8709a-003a-0000-ebf9-90cea7d9d44f'], //'potassium'
      ]
      let insignificantSources = sources1.filter(s => (parseFloat(nfp[s]?.percent)) < 2)

      //Total sugars is insignificant if less than 1g
      if(!nfp['84a8709a-0006-0000-ebf9-90cea7d9d44f']?.value || nfp['84a8709a-0006-0000-ebf9-90cea7d9d44f']?.value < 1) { 
        insignificantSources.push(nfp['84a8709a-0006-0000-ebf9-90cea7d9d44f'])
      }
      let insignificantSources2 = sources2.filter(s => (parseFloat(s?.percent)) < 2)
      if(insignificantSources2?.length) {
        insignificantSources = [...insignificantSources, ...insignificantSources2]
      }

      let text = []
      if(insignificantSources.length > 0) {
        if(insignificantSources.length > 2) {
          let last = insignificantSources.pop()
          text = insignificantSources.map(s => <>{getLabel(s, lds.isAbbreviated)}<span>, </span></>)
          text.push(<><span> and </span>{getLabel(last, lds.isAbbreviated, true, true)}</>)
          
        } else if (insignificantSources.length > 1) {
          text = [getLabel(insignificantSources[0], lds.isAbbreviated), <span> and </span>, getLabel(insignificantSources[1], lds.isAbbreviated, true, true)]
        } else {
          text = [getLabel(insignificantSources[0], lds.isAbbreviated, true, true)]
        }
        text.unshift(<span>Not a significant source of </span>)
      }
      return text
    }


  const getBreadcrumb = () => {
    let breadcrumb = <span><ArticleIcon /> Label Declaration Sheet Entry <CanadianFlagIcon/></span>;
    return breadcrumb;
  }

  const getCommandBar = () => {
    let commandBar;
    commandBar =
    <RoleContext.Consumer>
      { roleCtx => (
      <div>
        {!isReadOnly && isDirty && !isSaving && <BlinkingBox sx={{display: 'inline-block'}}>
          <ForwardIcon sx={{color: '#1976d2'}} fontSize="large" />
        </BlinkingBox>}
        {!isReadOnly && <Button size="small" variant="contained" sx={{
          marginRight:'.5em',
          ...(isDirty && !isSaving && { animation: `${pulse} 1.5s infinite` }),
          ...(isSaving && { animation: 'none' })
        }} disabled={!isDirty || isSaving} onClick={async (event) => {
          await save(event)
        }}>{lds?.id ? 'Save' : 'Create'}</Button>}

        <Button size="small" variant="contained" sx={{marginRight:'.5em'}} onClick={() => {
          if (!isReadOnly && isDirty) {
            setShowCancelModal(true)
          } else {
            navigate(`/label-declaration-sheets/regulation/${lds.formula?.regulation?.id}`);
          }
        }}>Cancel</Button>
        {/* { roleCtx.hasRole([ROLES.ADMIN, ROLES.SRA_ADMIN, ROLES.SRA_USER]) &&
          <Button size="small" variant="contained" sx={{marginRight:'.5em'}} onClick={(event) => {
            downloadLds(event, false);
          }}><DownloadIcon /> Word</Button>
        } */}
        <Button size="small" variant="contained" sx={{marginRight:'.5em'}} onClick={(event) => {
          downloadLds(event, true);
        }}><DownloadIcon /> PDF</Button>
         { FeatureFlags.isShareEnabled && roleCtx.hasRole([ROLES.ADMIN, ROLES.SRA_ADMIN, ROLES.SRA_USER]) &&
          <Button size="small" variant="contained" sx={{marginRight:'.5em'}} onClick={(_event) => {
            setEmailTo([])
            setIsEmailDialogVisible(true);
          }}>Share&nbsp;&nbsp;<ShareIcon/></Button>
        }
      </div>
      )}
    </RoleContext.Consumer>

    return commandBar;
  }

const downloadLds = async (event, isPdf) => {
    event.preventDefault();
    let productIngredientStatement = ''
    productIngredientStatement = lds.isIngredientsPrefixVisible ? 
      `<span>${ ('' + ldsInfo.ingredients).replace(/^\s*ingredients:\s*/i, '<strong>$&</strong>')}</span>` :
      ('' + ldsInfo.ingredients).replace(/^\s*ingredients:\s*/i, '')
    if(lds) {
      setIsLoading(true)
      let templateData = {
        ldsStatus: lds.status,
        productName: lds.product?.name,
        productReason: ldsInfo.reasonForIssuance ?? '',
        productSoi: ldsInfo.statementOfIdentity ?? '',
        productNetQuantity: ldsInfo.netQuantityOfContentsFreeForm ?? '',
        productFrontOfPack: ldsInfo.frontOfPackDeclarationFreeForm ?? '',
        productJuiceStatement: ldsInfo.juiceContentFinalValue ?? '',
        productIngredientStatement: productIngredientStatement ?? '',
        productManufacturerInfo: ldsInfo.finalManufacturersStatement ?? '',
        productCountryOfOrigin: ldsInfo.countryOfOriginStatement ?? '',
        productAllergenStatement: ldsInfo.allergensNotes ?? '',
        productNutrientContentClaim: ldsInfo.nutrientContentHealthClaimFreeForm ? `(Nutrient Content Claim): ${(he.decode(ldsInfo.nutrientContentHealthClaimFreeForm.replace(/(<([^>]+)>)/gi, "")))}` : '',  
        productQualifyingLanguage: ldsInfo.otherInformationClaimsFreeForm ? `(Other Claims): ${(he.decode(ldsInfo.otherInformationClaimsFreeForm.replace(/(<([^>]+)>)/gi, "")))}` : '',
        productOtherClaims: ldsInfo.otherInformation ?? '',
        productBlendStatement: ldsInfo.blendStatement ?? '',
        productCaffeineInformation: ldsInfo.caffeineQuantitativeClaimFreeForm ?? '',
        productOrganicInformation: ldsInfo.organicInformation ? `(Organic Information): ${ldsInfo.organicInformation}` : '',
        productReconstitutionInstructions: ldsInfo.reconstitutionInstructions ?? '',
        productStorageUseInstructions: ldsInfo.storageUseInstructions ?? '',
        productPkuWarningStatement: ldsInfo.pkuWarningStatement ?? '',
        productConsumerInquiries: ldsInfo.consumerInquiriesFreeForm ?? '',
        productKosher: ldsInfo.kosherFreeForm ?? '',
        productLabelCode: ldsInfo.labelCode ?? '',
        notes: lds.notes ?? '',
        formulaBbn: lds.formula?.bbn,
        issueDate: lds.formula?.issueDate ?? '',
        revisedDate: lds.updatedAt ? moment(lds.updatedAt).format('MM/DD/YYYY') : moment().format('MM/DD/YYYY'),
        replaceBbn: ldsInfo.replaceBbn ?? '',
        sfdcProductLink: id,
        frontOfPackageLabel: ''
      }
      templateData.productNutrientContentClaim = templateData.productNutrientContentClaim.replace(/\n/g, '<br/>')
      templateData.productNutrientContentClaim = ('' + templateData.productNutrientContentClaim).endsWith('.') ? templateData.productNutrientContentClaim : ('' + templateData.productNutrientContentClaim).length > 0 ? templateData.productNutrientContentClaim + '.' : ''
      templateData.productQualifyingLanguage = ('' + templateData.productQualifyingLanguage).endsWith('.') ? templateData.productQualifyingLanguage : ('' + templateData.productQualifyingLanguage).length > 0 ? templateData.productQualifyingLanguage + '.' : ''
      

      let inputFileName = `LabelDeclarationSheet${isPdf ? '.pdf' : '.docx'}`;
      let nfpView = {}
      if(lds.layout === 'standard') {
        nfpView = document.getElementById('nutrition-fact-panel-standard')
      }
      if(lds.layout === 'supplemented') {
        nfpView = document.getElementById('nutrition-fact-panel-supplemented')
      } 
      if(lds.layout === 'suppressed') {
        nfpView = document.getElementById('nutrition-fact-panel-suppressed')
      }    

      let frontOfPackageLabel = document.getElementById('front-of-package-label')
      if(lds.layout === 'supplemented') {
        if(lds.isSupplementedFoodFactsRequired) {
          let supplementedFoodFacts = document.getElementById('supplemented-food-facts')  
          templateData.supplementedFoodFacts = `<tr>
					<td>Supplemented Foods Caution Identifier Required?</td>
					<td>${supplementedFoodFacts.outerHTML}</td>
				</tr>`
        } else {
          templateData.supplementedFoodFacts = `<tr>
            <td>Supplemented Foods Caution Identifier Required?</td>
            <td>No</td>
          </tr>`
        }
      } else {
        templateData.supplementedFoodFacts = ''
      }
      templateData.hasFrontOfPackageLabel = frontOfPackageLabel !== null
      if(templateData.hasFrontOfPackageLabel) {
        templateData.frontOfPackageLabel = frontOfPackageLabel.outerHTML
      }
      templateData.nfp = nfpView.outerHTML

      const requestConfig = await getRequestConfig()
      let response
      if(isPdf) {
        templateData.sfdcProductLink = `<a href="${SraSfdcDomain}/${id}">${id}</a>`
        const replacePlaceholders = (template, values) => {
          // Regular expression to find placeholders in the form {propertyName}
          const regex = /\{(.+?)\}/g;
          
          // Replace placeholders with corresponding property values
          return template.replace(regex, (match, captureGroup) => {
            // Return the value from the object if it exists, otherwise leave the placeholder as is
            return captureGroup in values ? values[captureGroup] ?? '' : match;
          });
        }
        const headerTemplate = replacePlaceholders(LabelDeclarationSheetPdfTemplate.header, templateData)
        const html = replacePlaceholders(LabelDeclarationSheetPdfTemplate.body, templateData)
        const footerTemplate = replacePlaceholders(LabelDeclarationSheetPdfTemplate.footer, templateData)

        const body = {
          html,
          options: {
            printBackground: false,
            pageWidth: null,
            pageNumbers: false,
            pageHeight: null,
            margin: {
              top: '1.25in',
              right: '0.75in',
              left: '0.75in',
              bottom: '1.25in'
            },
            landscape: lds.layout === 'tabular',
            displayHeaderFooter: true,
            headerTemplate: headerTemplate,
            footerTemplate: footerTemplate
          }
        }
        response = await axios.post(`${ApiGateway.pdfService}/generate`, body, requestConfig)
      } else {
        let convertToImage = ['nfp']
        if(templateData.hasFrontOfPackageLabel) {
          convertToImage.push('frontOfPackageLabel')
        }
        console.log('templateData: ', templateData)
        const body = {
          convertToImage: convertToImage,
          htmlKeys: [ 
            'productSoi', 'productNetQuantity', 'productFrontOfPack', 'productJuiceStatement', 'productIngredientStatement', 
            'productManufacturerInfo', 'productCountryOfOrigin', 'productAllergenStatement', 'productNutrientContentClaim',
            'productQualifyingLanguage', 'productOtherClaims', 'productBlendStatement', 'productCaffeineInformation', 
            'productOrganicInformation', 'productReconstitutionInstructions', 'productStorageUseInstructions', 'productPkuWarningStatement', 
            'productConsumerInquiries', 'productKosher', 'sfdcProductLink'],
          data: templateData,
          template: inputFileName
        }
        try {
          response = await axios.post(`${ApiGateway.documentGeneration}/docxFromTemplate?fullPage=false`, body, requestConfig)
        } catch (e) {
          try {
            response = await axios.post(`${ApiGateway.documentGeneration}/docxFromTemplate?fullPage=false`, body, requestConfig)
          } catch (e2) {
            bus.emit(Event.ALERT, {
              text: 'Could not generate the document, please try again...',
              style: 'warn'
            })
          }
        }
      }

      if (response && response.data) {
        // console.log('response: ', response);
        let blob = b64toBlob(response.data, 'binary/octet-stream');
        let fileName = ('' + lds.product?.name).replace(/[^a-zA-Z0-9\s.\-]/g, '_')
        fileName += lds.formula?.regulation?.countryId === 124 ? '-CA' : '-US'
        fileName += isPdf ? '.pdf' : '.docx'
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // If IE, you must uses a different method.
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          let url = URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.style = 'display:none';
          document.body.appendChild(a);
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }
      }
      setIsLoading(false)
    }
  }

  const save = async(event) => {
    if(nfp1) {
      let nfp1Ids = [...Object.keys(nfp1)]
      if(nfp1Ids.length > 0) {
        setIsSaving(true)
        const requestConfig = await getRequestConfig()
        let newLds = {
          status: lds.status,
          layout: lds.layout,
          version: lds.version,
          product: {
            id: lds.product?.id
          },
          notes: lds.notes,
          isIngredientsPrefixVisible: lds.isIngredientsPrefixVisible,
          isSupplementedFoodFactsRequired: lds.isSupplementedFoodFactsRequired,
          nfp1: {
            nutrientInfos: nfp1Ids.map(id => {
              return {
                nutrient: { id, name: nfp1[id].label },
                amountState: nfp1[id].amountState,
                percentState: nfp1[id].percentState,
                isSupplement: nfp1[id].isSupplement
              }
            })
          }
        }
        let response
        if(lds.id) {
          newLds.id = lds.id
          response = await axios.put(`${basePath}/lds/${lds.id}`, newLds, requestConfig)
        } else {
          response = await axios.post(`${basePath}/lds`, newLds, requestConfig)
        }
        if(response.status === 200) {
          let savedLds = structuredClone(lds)
          savedLds.version = response.data?.version
          savedLds.id = response.data?.id
          setLds(savedLds)
          setIsDirty(false)
          bus.emit(Event.ALERT, {
            text: 'Saved Successfully!',
            style: 'success',
            duration: 2000
          })
        } else {
          bus.emit(Event.ALERT, {
            text: 'There was an issue saving... please try again later',
            style: 'error'
          })
        }
        setIsSaving(false)
      }
    }
  }

  const handleTabChange = async (_event, activeTab) => {
    setActiveTab(activeTab)
  }
  

  const shareLds = async (event) => {
    event.preventDefault();

    let body = `
      <div>
        <p>${emailBody}</p>
        <br/>
        <p style="margin-top: 1.5em; padding: 1em; border: 1px dashed #999; border-radius: 6px">
          <p>${lds?.product?.name}: ${id}</p>
          <p>LDS Assessment Link: <a target="_blank" href="${SraPortalDomain}/label-declaration-sheets/ca/products/${id}/entry">${SraPortalDomain}/label-declaration-sheets/ca/products/${id}/entry</a></p>
          <p>SFDC Link: <a target="_blank" href="${SraSfdcDomain}/${id}">${SraSfdcDomain}/${id}</a></p>
        </p>
        <p style="margin-top:1.5em; font-size:12px; color:#999; font-style:italic">Please Note: This message is intended only for the individual or entity to which it is addressed and may contain information that is confidential and/or privileged. If you received this email in error, please delete it and notify the sender immediately. Any dissemination, distribution or copying of this communication by someone other than the intended recipient, is strictly prohibited.</p>
      </div>
    `

    if(Array.isArray(emailTo) && emailTo.length > 0){
      let share = {
        from: account?.idTokenClaims?.mail,
        to: emailTo.map(e => e.email).join(';'),
        subject: emailSubject,
        body: body
      }
      const requestConfig = await getRequestConfig()
      const emailResponse = await axios.post(`${ApiGateway.email}/send`, share, requestConfig)
      if(emailResponse.status === 200) {
        setEmailError(false);
        setIsEmailDialogVisible(false)
        bus.emit(Event.ALERT, {
          text: 'Email Sent Successfully!',
          style: 'success',
          duration: 2000
        })
      } else {
        bus.emit(Event.ALERT, {
          text: 'There was an error sharing the LDS.  Please try again later.',
          style: 'error'
        })
      }
    } else {
      setEmailError(true);
    }
  }

  return (
    <Page { ...props} breadcrumb = {getBreadcrumb()} commandBar={getCommandBar()} isLoading={isLoading} isSaving={isSaving}>
      {/* <Button onClick={()=> {console.log('isDirty: ', isDirty); console.log('isSaving: ', isSaving);}}>Show State</Button> */}
      <Grid container>
          <Grid size={6}>
              <Paper sx={{padding: '.5em 1em'}}>
                {lds.id && <Grid container>
                  <Grid size={3}>LDS Version:</Grid>
                  <Grid size={9}>{lds.version?.major ?? '0'}.{lds.version?.minor ?? '0'}.{lds.version?.revision ?? '0'}</Grid>
                </Grid>}                
                <Grid container>
                  <Grid size={3}>Salesforce Product ID:</Grid>
                  <Grid size={9}>{id} <StatusChip status={lds.product?.status}/></Grid>
                  <Grid size={3}>Product Name:</Grid>
                  <Grid size={9}><a href={`${SraSfdcDomain}/${id}`} target="_blank">{lds.product?.name}</a></Grid>
                </Grid>
                <br/>
                <Grid container>
                  <Grid size={3}>Formula Name:</Grid>
                  <Grid size={9}>{lds.formula?.formulaName}</Grid>
                  <Grid size={3}>BBN:</Grid>
                  <Grid size={9}>{lds.formula?.bbn}</Grid>
                </Grid>
              </Paper>

              {!isReadOnly &&
              <Panel title="Layout Options" sx={{margin:'1em 0'}}>
                  <Grid container rowSpacing={1}>
                      <Grid container size={6}>
                          <Grid size={6}>LDS Status:</Grid>
                          <Grid size={6}>
                            <Select id="status" size="small" value={lds.status} onChange={(event) => {handleSelectChange('status', event, lds, setLds, setDirty)}}>
                              <MenuItem value="obsolete"><Tooltip title="This item is no longer valid or active." placement="right" arrow>Obsolete</Tooltip></MenuItem>
                              <MenuItem value="review"><Tooltip title="This item is being reviewed, subject to change." placement="right" arrow>Under Review</Tooltip></MenuItem>
                              <MenuItem value="approved"><Tooltip title="This item has been approved and is final/active." placement="right" arrow>Approved</Tooltip></MenuItem>
                            </Select>
                          </Grid>
                      </Grid>
                      <Grid container size={6}>
                          <Grid size={4}>Layout:</Grid>
                          <Grid size={8}>
                            <Select id="layout" size="small" value={lds.layout} onChange={(event) => {handleSelectChange('layout', event, lds, setLds, setDirty)}}>
                              <MenuItem value="">Select One</MenuItem>
                              <MenuItem value="standard">Standard Nutrition Facts</MenuItem>
                              <MenuItem value="supplemented">Supplemented Nutrition Facts</MenuItem>
                              <MenuItem value="suppressed">Suppressed</MenuItem>
                            </Select>
                          </Grid>
                      </Grid>
                      {lds.layout === 'supplemented' && 
                      <>
                        <Grid size={6}></Grid>
                        <Grid size={6}>
                          <Typography component="span">Supplemented Foods Caution Identifier Required?</Typography>
                          <Checkbox id="isSupplementedFoodFactsRequired" size="small" checked={lds.isSupplementedFoodFactsRequired} onChange={(event) => {handleCheckboxChange('isSupplementedFoodFactsRequired', event, lds, setLds, setDirty)}} />
                        </Grid>
                      </>
                      }
                  </Grid>
              </Panel>
              }
              <Panel>
                <Tabs value={activeTab} onChange={handleTabChange} textColor="primary" indicatorColor="primary">
                  <Tab label="Nfp" variant="contained" value="Nfp"/>
                  <Tab label="LDS Info" value="LDS Info"/>
                  {/* <Tab label="Collaborators" value="Collaborators"/>
                  <Tab label="History" value="History"/> */}
                </Tabs>
                <TabPanel value={activeTab} forTab="Nfp">
                  {lds && <Grid container spacing={2}>
                    <Grid container size={12} >
                      {lds.serve === 'multi' && <Grid size={12}>
                        <LDSInput label="Servings per Container" readOnly={isReadOnly} showToggles={ false } labelSize={3.4} id="servingsPerContainer" fullWidth value={lds.product?.servingsPerContainer ?? ''} onChange={(event) => { const { target } = event; handleFieldChange(target.id, target.value, lds.nfp1.servingsPerContainer, setLds, setDirty)}} />
                      </Grid>}
                      <Grid size={12}>
                        <LDSInput label="Serving Size" readOnly={isReadOnly} showToggles={ false } labelSize={3.4} id="servingSize" fullWidth value={lds.product?.servingSize ?? ''} />
                      </Grid>
                      <Grid size={12}>
                        <HorizontalRule thickness={8} />
                      </Grid>
                      {nfp1 && [...Object.keys(nfp1)].map((id) => (
                        <>
                          {nfp1[id].includeInView && lds.layout === 'standard' && <>
                            <Grid size={8}>
                              {nfp1[id].showAmount && <LDSInput readOnly={isReadOnly} nfp={nfp1[id]} label={nfp1[id].label} showToggles={ !nfp1[id].isMandatory } id={`${id}.value`} fullWidth value={nfp1[id].value} checkState={nfp1[id].amountState} onChange={(event) => { const { target } = event; handleFieldChange(id, target.value, nfp1[id].value, setNfp1AmountState, setDirty)}} />}
                              {!nfp1[id].showAmount && nfp1[id].name}
                            </Grid>
                            <Grid size={4}>
                              {nfp1[id].showPercent && <LDSInput readOnly={isReadOnly} nfp={nfp1[id]} label="%DV" labelSize={3} showToggles={ !nfp1[id].isMandatory || nfp1[id].isMicroNutrient } id={`${id}_percent`} fullWidth value={nfp1[id].percent} checkState={nfp1[id].percentState} onChange={(event) => { const { target } = event; handleFieldChange(id, target.value, nfp1[id].percent, setNfp1PercentState, setDirty)}} />}
                            </Grid>
                          </>}
                          {nfp1[id].includeInView && lds.layout === 'suppressed' && <>
                            <Grid size={8}>
                              {nfp1[id].showAmount && <LDSInput readOnly={isReadOnly} nfp={nfp1[id]} label={nfp1[id].label} showToggles={ !nfp1[id].isMandatory } id={`${id}.value`} fullWidth value={nfp1[id].value} checkState={nfp1[id].amountState} onChange={(event) => { const { target } = event; handleFieldChange(id, target.value, nfp1[id].value, setNfp1AmountState, setDirty)}} />}
                              {!nfp1[id].showAmount && nfp1[id].name}
                            </Grid>
                            <Grid size={4}>
                              {nfp1[id].showPercent && <LDSInput readOnly={isReadOnly} nfp={nfp1[id]} label="%DV" labelSize={3} showToggles={ !nfp1[id].isMandatory || nfp1[id].isMicroNutrient } id={`${id}_percent`} fullWidth value={nfp1[id].percent} checkState={nfp1[id].percentState} onChange={(event) => { const { target } = event; handleFieldChange(id, target.value, nfp1[id].percent, setNfp1PercentState, setDirty)}} />}
                            </Grid>
                          </>}
                          {nfp1[id].includeInView && lds.layout === 'supplemented' && !nfp1[id].isMicroNutrient && <>
                            <Grid size={8}>
                              {nfp1[id].showAmount && <LDSInput readOnly={isReadOnly} nfp={nfp1[id]} label={nfp1[id].label} showToggles={ !nfp1[id].isMandatory } id={`${id}.value`} fullWidth value={nfp1[id].value} checkState={nfp1[id].amountState} onChange={(event) => { const { target } = event; handleFieldChange(id, target.value, nfp1[id].value, setNfp1AmountState, setDirty)}} />}
                              {!nfp1[id].showAmount && nfp1[id].name}
                            </Grid>
                            <Grid size={4}>
                              {nfp1[id].showPercent && <LDSInput readOnly={isReadOnly} nfp={nfp1[id]} label="%DV" labelSize={3} showToggles={ !nfp1[id].isMandatory } id={`${id}_percent`} fullWidth value={nfp1[id].percent} checkState={nfp1[id].percentState} onChange={(event) => { const { target } = event; handleFieldChange(id, target.value, nfp1[id].percent, setNfp1PercentState, setDirty)}} />}
                            </Grid>
                          </>}
                          {nfp1[id].includeInView && lds.layout === 'supplemented' && nfp1[id].isMicroNutrient && !nfp1[id].isSupplement && <>
                            <Grid size={8}>
                              {nfp1[id].showAmount && <LDSInput readOnly={isReadOnly} nfp={nfp1[id]} label={nfp1[id].label} icon={
                                <Tooltip title="Add to Supplements" arrow>
                                  <ArrowCircleDown sx={{cursor: 'pointer'}} onClick={() => { setSupplement1(id, true) }}/>
                                </Tooltip>
                                } showToggles={ !nfp1[id].isMandatory } id={`${id}.value`} fullWidth value={nfp1[id].value} checkState={nfp1[id].amountState} onChange={(event) => { const { target } = event; handleFieldChange(id, target.value, nfp1[id].value, setNfp1AmountState, setDirty)}} />}
                              {!nfp1[id].showAmount && nfp1[id].name}
                            </Grid>
                            <Grid size={4}>
                              {nfp1[id].showPercent && <LDSInput readOnly={isReadOnly} nfp={nfp1[id]} label="%DV" labelSize={3} showToggles={ !nfp1[id].isMandatory } id={`${id}_percent`} fullWidth value={nfp1[id].percent} checkState={nfp1[id].percentState} onChange={(event) => { const { target } = event; handleFieldChange(id, target.value, nfp1[id].percent, setNfp1PercentState, setDirty)}} />}
                            </Grid>
                          </>}
                          { id === '84a8709a-003c-0000-ebf9-90cea7d9d44f' &&
                            <Grid size={12}>
                              <HorizontalRule thickness={4} />
                            </Grid>
                          }
                        </>
                      ))}
                      {nfp1 && lds.layout === 'supplemented' && 
                        <>
                          <Grid size={12}>
                            <HorizontalRule thickness={4} />
                          </Grid>
                          <Typography variant="h4">Supplemented with / Supplémenté en</Typography>
                        </>
                      }
                      {nfp1 && lds.layout === 'supplemented' && [...Object.keys(nfp1)].map((id) => (
                        <>
                          {nfp1[id].includeInView && nfp1[id].isSupplement && <>
                            <Grid size={8}>
                              {nfp1[id].showAmount && <LDSInput readOnly={isReadOnly} nfp={nfp1[id]} icon={
                                <Tooltip title="Remove from Supplements" arrow>
                                  <ArrowCircleUp sx={{cursor: 'pointer'}} onClick={() => { setSupplement1(id, false) }}/>
                                </Tooltip>} label={nfp1[id].label} showToggles={ true } id={`${id}.value`} fullWidth value={nfp1[id].value} checkState={nfp1[id].amountState} onChange={(event) => { const { target } = event; handleFieldChange(id, target.value, nfp1[id].value, setNfp1AmountState, setDirty)}} />}
                              {!nfp1[id].showAmount && nfp1[id].name}
                            </Grid>
                            <Grid size={4}>
                              {nfp1[id].showPercent && <LDSInput readOnly={isReadOnly} nfp={nfp1[id]} label="%DV" labelSize={3} showToggles={ true } id={`${id}_percent`} fullWidth value={nfp1[id].percent} checkState={nfp1[id].percentState} onChange={(event) => { const { target } = event; handleFieldChange(id, target.value, nfp1[id].percent, setNfp1PercentState, setDirty)}} />}
                            </Grid>
                          </>}
                        </>
                      ))}
                    </Grid>
                  </Grid>}
                </TabPanel>
                <TabPanel value={activeTab} forTab="LDS Info">
                  {ldsInfo && <Grid container spacing={2}>
                    <Grid container size={12} sx={{padding: '.5em'}}>
                      <Grid size={4}>
                        <Typography>Statement of Identity</Typography>
                      </Grid>
                      <Grid size={8}>
                        <Typography dangerouslySetInnerHTML={{__html: (ldsInfo.statementOfIdentity ?? '').replace(/\r\n/g, '<br/>')}} />
                      </Grid>

                      <Grid size={4}>
                        <Typography>Net Quantity of Contents</Typography>
                      </Grid>
                      <Grid size={8}>
                        <Typography dangerouslySetInnerHTML={{__html: (ldsInfo.netQuantityOfContentsFreeForm ?? '').replace(/\r\n/g, '<br/>')}} />
                      </Grid>

                      <Grid size={4}>
                        <Typography>Front-of-Pack Declaration</Typography>
                      </Grid>
                      <Grid size={8}>
                        <Typography dangerouslySetInnerHTML={{__html: (ldsInfo.frontOfPackDeclarationFreeForm ?? '').replace(/\r\n/g, '<br/>')}} />
                      </Grid>
                    </Grid>

                    <Grid container size={12} sx={{padding: '.5em', borderTop: '1px dashed #ccc', borderBottom: '1px dashed #ccc'}}>
                      <Grid size={4} >
                        <Typography>Juice Content</Typography>
                      </Grid>
                      <Grid size={8}>
                        {ldsInfo.juiceContentFinalValue  && <Typography dangerouslySetInnerHTML={{__html: ('(Juice Content Label Claim): ' + (ldsInfo.juiceContentFinalValue ?? '')).replace(/\r\n/g, '<br/>')}} />}
                      </Grid>
                    
                      <Grid size={4}>
                        <Typography>Ingredient Statement (English)</Typography>
                        { /^\s*ingredients:\s*/i.test(ldsInfo.ingredients) &&
                          <>
                            <Typography component="span" sx={{fontSize: '12px', color: '#999', fontStyle: 'italic'}}>Show "Ingredients: " prefix?</Typography>
                            <Checkbox id="isIngredientsPrefixVisible" size="small" checked={lds.isIngredientsPrefixVisible} onChange={(event) => {handleCheckboxChange('isIngredientsPrefixVisible', event, lds, setLds, setDirty)}} />
                          </>
                        }
                      </Grid>
                      <Grid size={8}>
                        <Typography>
                          {lds.isIngredientsPrefixVisible ? (
                            <Typography component="span">
                              {(() => {
                                const ingredientsText = '' + ldsInfo.ingredients;
                                const match = ingredientsText.match(/^\s*ingredients:\s*/i);
                                if (match) {
                                  const prefixLength = match[0].length;
                                  return (
                                    <>
                                      <strong>{match[0]}</strong>
                                      {ingredientsText.slice(prefixLength)}
                                    </>
                                  );
                                } else {
                                  return ingredientsText;
                                }
                              })()}
                            </Typography>
                          ) : (
                            (ldsInfo.ingredients ?? '').replace(/^\s*ingredients:\s*/i, '').replace(/\r\n/g, '<br/>')
                          )}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container size={12} sx={{padding: '.5em'}}>
                      <Grid size={4}>
                        <Typography>Country of Origin Statement</Typography>
                      </Grid>
                      <Grid size={8}>
                        <Typography dangerouslySetInnerHTML={{__html: (ldsInfo.countryOfOriginStatement ?? '').replace(/\r\n/g, '<br/>')}} />
                      </Grid>

                      <Grid size={4}>
                        <Typography>Allergen Statement</Typography>
                      </Grid>
                      <Grid size={8}>
                        <Typography dangerouslySetInnerHTML={{__html: (ldsInfo.allergensNotes ?? '').replace(/\r\n/g, '<br/>')}} />
                      </Grid>
                    </Grid>
                    
                    <Grid container size={12} sx={{padding: '.5em', borderTop: '1px dashed #ccc', borderBottom: '1px dashed #ccc'}}>
                      <Grid size={4}>
                        <Typography>Claims and Qualifying Language</Typography>
                      </Grid>
                      <Grid size={8}>
                        <div> {ldsInfo.nutrientContentHealthClaimFreeForm ? ('(Nutrient Content Claim): ' + (ldsInfo.nutrientContentHealthClaimFreeForm ?? '')).replace(/\r\n/g, '<br/>').replace(/(<([^>]+)>)/gi, "").split(/[\r\n]/).map((item, idx) => {
                          return (
                            <span key={`nutrientContentHealthClaimFreeForm-${idx}`}>
                              {he.decode(item)}
                              <br/>
                            </span>
                          )
                        }) : ''} </div>
                        <div> {ldsInfo.otherInformationClaimsFreeForm ? ('(Other Claims): ' + (ldsInfo.otherInformationClaimsFreeForm ?? '')).replace(/\r\n/g, '<br/>').replace(/(<([^>]+)>)/gi, "").split(/[\r\n]/).map((item, idx) => {
                          return (
                            <span key={`otherInformationClaimsFreeForm-${idx}`}>
                              {he.decode(item)}
                              <br/>
                            </span>
                          )
                        }) : ''} </div>
                      </Grid>

                      <Grid size={4}>
                        <Typography>Kosher</Typography>
                      </Grid>
                      <Grid size={8}>
                        <Typography dangerouslySetInnerHTML={{__html: (ldsInfo.kosherFreeForm ?? '').replace(/\r\n/g, '<br/>')}} />
                      </Grid>
                    </Grid>
                    
                    <Grid container size={12} sx={{padding: '.5em'}}>
                      <Grid size={4}>
                        <Typography>Other Label Information (i.e. Blend Statement; PKU Warning Statement; Caffeine info.; Organic info.; Reconstitution instructions; Storage/use instructions;)</Typography>
                      </Grid>
                      <Grid size={8}>
                        {ldsInfo.blendStatement && <Typography dangerouslySetInnerHTML={{__html: ('(Blend Statement): ' + ldsInfo.blendStatement).replace(/\r\n/g, '<br/>')}} />}
                        {ldsInfo.caffeineQuantitativeClaimFreeForm && <Typography dangerouslySetInnerHTML={{__html: ('(Caffeine Information): ' + ldsInfo.caffeineQuantitativeClaimFreeForm).replace(/\r\n/g, '<br/>')}} />}
                        {ldsInfo.organicInformation && <Typography dangerouslySetInnerHTML={{__html: ('(Organic Information): ' + ldsInfo.organicInformation).replace(/\r\n/g, '<br/>')}} />}
                        {ldsInfo.reconstitutionInstructions && <Typography dangerouslySetInnerHTML={{__html: ('(Reconstitution Instructions): ' + ldsInfo.reconstitutionInstructions).replace(/\r\n/g, '<br/>')}} />}
                        {ldsInfo.storageUseInstructions && <Typography dangerouslySetInnerHTML={{__html: ('(Storage Use Instructions): ' + ldsInfo.storageUseInstructions).replace(/\r\n/g, '<br/>')}} />}
                        {ldsInfo.pkuWarningStatement && <Typography dangerouslySetInnerHTML={{__html: ('(PKU Warning Statement): ' + ldsInfo.pkuWarningStatement).replace(/\r\n/g, '<br/>')}} />}
                        {ldsInfo.consumerInquiriesFreeForm && <Typography dangerouslySetInnerHTML={{__html: ('(Consumer Inquiries Freeform): ' + ldsInfo.consumerInquiriesFreeForm).replace(/\r\n/g, '<br/>')}} />}
                        {ldsInfo.otherInformation && <Typography dangerouslySetInnerHTML={{__html: ('(Blend Statement): ' + ldsInfo.otherInformation).replace(/\r\n/g, '<br/>')}} />}
                      </Grid>

                      <Grid size={4}>
                        <Typography>Label Code</Typography>
                      </Grid>
                      <Grid size={8}>
                        <Typography>{ldsInfo.labelCode}</Typography>
                      </Grid>
                      <Grid size={4}>
                        <Typography>Notes</Typography>
                      </Grid>
                      <Grid size={8}>
                        <TextField 
                          slotProps={{
                            input: {
                              readOnly: isReadOnly
                            },
                          }}
                          sx={isReadOnly ? {
                            '& .MuiOutlinedInput-root': {
                              padding: 0,
                              '&.MuiOutlinedInput-root fieldset': {
                                borderColor: 'transparent', // Removes focus border,
                              },
                            },
                          } : {}}                    
                          multiline
                          rows={8}
                          value={lds.notes}
                          onChange={(e) => handleFieldChange('notes', e.target?.value, lds, setLds, setDirty)}
                          variant="outlined"
                          fullWidth
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  }
                </TabPanel>
                <TabPanel value={activeTab} forTab="Collaborators">
                  Content for Collaborators
                </TabPanel>
                <TabPanel value={activeTab} forTab="History">
                  Content for History
                </TabPanel>
              </Panel>
          </Grid>
          <Grid size={6}>
            <div style={{ position: "fixed", top: "106px", left: '50%', transform: 'translateX(170px)',  height:"100vh" }}>
              <Box sx={{width: '100% - 270px'}}>
                {lds.layout === 'standard' &&
                <NfpStandardView 
                  nfp={nfp1 ?? {}} 
                  lds={lds}
                />}
                {lds.layout === 'supplemented' &&
                  <NfpSupplementedView
                    nfp={nfp1 ?? {}} 
                    lds={lds}
                  />
                }
                {lds.layout === 'suppressed' &&
                  <NfpSuppressedView
                    nfp={nfp1 ?? {}} 
                    lds={lds}
                  />
                }
                <Box>Please note the Nutrition Facts is not camera ready. Kindly use the correct template.</Box>
              </Box>
            </div>
          </Grid>
      </Grid>

      <EmailDialog
        open={isEmailDialogVisible}
        onSend={shareLds}
        content={  
          <Grid container size={12} rowSpacing={1}>
            <Grid size={1} sx={{textAlign: 'right', padding: '1em' }}>
              From: 
            </Grid>
            <Grid size={11}>
              <TextField disabled fullWidth value={`${account?.name} <${account?.idTokenClaims?.mail}>`}/>
            </Grid>
            <Grid size={1} sx={{textAlign: 'right', padding: '1em' }}>
              To: 
            </Grid>
            <Grid size={11}>
              <Autocomplete 
                multiple
                options={allSraUsers} 
                value={emailTo}
                onChange={(event, newValue) => {setEmailTo(newValue); setEmailError(false)}}
                getOptionLabel={ option => `${option.lastName}, ${option.firstName}` } 
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={emailError}
                    helperText={emailError ? "This field is required." : ''}
                    slotProps={{
                      htmlInput: {
                        ...params.inputProps,
                        autoComplete: 'off', // disable autocomplete and autofill
                      },
                    }}
                  />
                )} 
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  return (
                    <Box
                      key={key}
                      component="li"
                      sx={{ zIndex: 9999 }}
                      {...optionProps}
                    >
                      {option.lastName}, {option.firstName}
                    </Box>
                  );
                }}            
              />
            </Grid>
            <Grid size={1} sx={{textAlign: 'right', padding: '1em' }}>
              Subject: 
            </Grid>
            <Grid size={11}>
              <TextField disabled fullWidth value={emailSubject}/>
            </Grid>            
            <Grid size={12}>
              <Box sx={{ padding: '1em', border: '1px solid #999', borderRadius: '6px'}}>
                <TextField multiline rows={3} fullWidth value={emailBody} placeholder="Add Optional Message" onChange={(e) => setEmailBody(e.target?.value)}/>
                <br/>
                <Box sx={{ marginTop: '1.5em', padding: '1em', border: '1px dashed #999', borderRadius: '6px'}}>
                  <Typography>{lds.product?.name}: <StatusChip status={id} color="default"/></Typography>
                  <Typography>LDS Assessment Link: <a target="_blank" href={`${SraPortalDomain}/label-declaration-sheets/ca/products/${id}/entry`}>{`${SraPortalDomain}/label-declaration-sheets/ca/products/${id}/entry`}</a></Typography>
                  <Typography>SFDC Link: <a target="_blank" href={`${SraSfdcDomain}/${id}`}>{`${SraSfdcDomain}/${id}`}</a></Typography>
                </Box>
                <Typography sx={{marginTop: '1.5em', fontSize: '12px', color: '#999', fontStyle: 'italic'}}>Please Note: This message is intended only for the individual or entity to which it is addressed and may contain information that is confidential and/or privileged. If you received this email in error, please delete it and notify the sender immediately. Any dissemination, distribution or copying of this communication by someone other than the intended recipient, is strictly prohibited.</Typography>
              </Box>
              
            </Grid>
          </Grid>
        }
        hideDialog={() => {
          setIsEmailDialogVisible(false)
        }}
        title={ <Typography><EmailIcon /> Share</Typography> }
      />      

      <Dialog open={showCancelModal}>
        <DialogTitle>Unsaved Changes</DialogTitle>

        <DialogContent>
          <p>You have unsaved changes. Are you sure you want to cancel?</p>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => {
            navigate(`/label-declaration-sheets/regulation/${lds.formula?.regulation?.id}`, 
              {
                message: {
                  message: 'Changes were discarded...',
                  type: 'info',
                  duration: 2000
                }
              }
            );
          }}>Discard Changes</Button>
          <Button onClick={() => {
            setShowCancelModal(false)
          }}>Continue Working</Button>
        </DialogActions>
      </Dialog>
    </Page>    
)}